import { h } from 'preact';
import React, { Component } from 'react';
import Switch from './Switch';
import { makeText, isActionAllowed } from '../../../util';
import NeutralButtons from '../../PMTCFv2InlineNeutral/NeutralButtons';

export default class Accordion extends Component {
  state = {
    open: false
  }
  toggleAccordion = (e) => {
    if (e === undefined || ['stack-toggle', 'opener', 'pm-switch', 'slider', 'view-all'].some(cssClass => e.target.className.includes(cssClass))) return;
    const panel = this.panel;
    const open = !this.state.open;
    this.setState({ open }, () => {
      if (this.props.force) this.props.force();
    });
    if (!open) {
      panel.style.maxHeight = null;
    } else {
      panel.style.maxHeight = panel.scrollHeight + 1000 + 'px';
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    const panel = this.panel;
    const open = nextState.open;
    if (panel && open) {
      setTimeout(() => {
        panel.style.maxHeight = panel.scrollHeight + 1000 + 'px';
      }, 150);
    }
  }
  render() {
    const {
      dev,
      name,
      description,
      content,
      selected,
      toggle,
      child,
      value,
      language,
      titleContent,
      vendors,
      plus,
      isCustom,
      locked,
      isApple,
      isCustomVendorLabel1,
      isCustomVendorLabel2,
      isCustomVendorLabel3,
      appleDataBrokerLetter,
      customVendorLabel1Letter,
      customVendorLabel2Letter,
      customVendorLabel3Letter,
      usePurModel,
      neutralPm,
    } = this.props;
    const { open } = this.state;
    const Settings = this.props.settings || {};

    const accordionStyles = {
      ...Settings.accordionsSpacing,
      ...Settings.accordionsFont
    };
    const panelStyles = {
      ...Settings.panelSpacing,
      ...Settings.panelFont
    };

    let partialConsent = false;
    let checked;
    if (child === 'vendors') {
      const { legIntCategories, consentCategories, active, legInt } = value;
      if (legIntCategories.length && consentCategories.length) {
        partialConsent = Boolean(active) !== Boolean(legInt);
      };
      checked = Boolean(active) || Boolean(legInt);
    } else {
      if (selected === 'li') {
        checked = value.legInt;
      } else if (selected === 'consent') {
        checked = value.active;
      } else {
        //if type is feature
        checked = value && (value.active || value.legInt);
      }
    }
    const toggleText = makeText(Boolean(dev), Settings, 'toggleText', language);
    const toggleOffText = makeText(Boolean(dev), Settings, 'toggleOffText', language);
    const descriptionWithoutTag = description ? description.slice(3).slice(0, -4) : '';

    return (
      <div
        tabIndex="0"
        className={plus ? 'tcfv2-stack plus focusable' : 'tcfv2-stack focusable'}
        onKeyDown={(e) => isActionAllowed(e.key) && this.toggleAccordion(e)}
      >
        <div className={isCustom ? 'stack-row custom' : 'stack-row'} style={{ position: 'relative' }}>
          <div
            className={open ? 'accordion active' : 'accordion'}
            style={accordionStyles}
            onClick={this.toggleAccordion}
          >
            {plus ? (
              <span className="plus-minus">{open ? '-' : '+'}</span>
            )
              : (
                <span className={open ? 'chevron up' : 'chevron down'} />
              )}
            {open && !titleContent
              ? (
                <span style={{ width: 230, }}>
                  <b>{name}</b>
                </span>
              )
              : (
                <span style={{ width: 230, }}>
                  {name}
                </span>
              )}
            {value && value.required && (
              <span style={{ paddingLeft: 5 }}>
                {Settings.requiredTagText}
              </span>
            )}
            {isApple && <span className="legend-key apple-broker">{appleDataBrokerLetter}</span>}
            {isCustomVendorLabel1 && <span className="legend-key is-custom-vendor-label-1" aria-hidden>{customVendorLabel1Letter}</span>}
            {isCustomVendorLabel2 && <span className="legend-key is-custom-vendor-label-2" aria-hidden>{customVendorLabel2Letter}</span>}
            {isCustomVendorLabel3 && <span className="legend-key is-custom-vendor-label-3" aria-hidden>{customVendorLabel3Letter}</span>}
            {titleContent ? titleContent : null}
          </div>
          {toggle
            ? !neutralPm
              ? (
                <Switch
                  type={Settings.toggleType}
                  color={Settings.toggleColor}
                  colorActive={Settings.toggleActiveColor}
                  offColor={Settings.toggleOffColor}
                  neutralColor={Settings.toggleNeutralColor}
                  offActiveColor={Settings.toggleOffActiveColor}
                  text={toggleText}
                  offText={toggleOffText}
                  toggle={toggle}
                  child={child}
                  vendors={vendors}
                  value={value}
                  locked={locked}
                  legInt={selected === 'li' ? true : false}
                  checked={checked}
                  tabbable
                  partialConsent={partialConsent}
                  consentType={child === 'vendors' ? 'all' : null}
                  dev={dev}
                  settings={Settings}
                  language={language}
                  usePurModel={usePurModel}
                />
              )
              : (
                <NeutralButtons
                  settings={Settings}
                  toggle={toggle}
                  vendors={vendors}
                  value={value}
                  child={child}
                  dev={dev}
                  language={language}
                />
              )
            : neutralPm && value && this.props.toggleStack && (
              <NeutralButtons
                settings={Settings}
                toggleStack={this.props.toggleStack}
                vendors={vendors}
                child={child}
                dev={dev}
                language={language}
                value={value}
              />
            )}
        </div>
        <div ref={c => this.panel = c} className="panel">
          {open && (
            <p style={{ ...panelStyles }}>
              {content ? React.cloneElement(content, { accordionOpen: open }) : descriptionWithoutTag}
            </p>
          )}
        </div>
      </div>
    );
  }
}